import React from 'react';
import { Content } from '../all-files/components';
import { CpFilesListView } from '../all-files/files-list-view';
import { CpAccountFilesSidePane } from './account-files-side-pane';
import { CpAccountFilesProps } from './types';

export const CpAccountFilesForMobile: React.FC<CpAccountFilesProps> = ({
  search,
  currentFolder,
  onFolderClick,
  data,
  currentAttachments,
  handleDownload,
  onFileClick,
  projectId,
  refetch,
}) => {
  if (!currentFolder) {
    return (
      <CpAccountFilesSidePane
        search={search}
        currentFolder={currentFolder}
        onFolderClick={onFolderClick}
        data={data}
        projectId={projectId}
        refetch={refetch}
      />
    );
  }

  return (
    <Content>
      <CpFilesListView
        onFileClick={(x) => onFileClick(x?.attachmentId)}
        attachments={currentAttachments}
        onDownload={(a) => handleDownload(a?.attachmentId)}
      />
    </Content>
  );
};
